import { render } from "./ProfitAndLossTable.vue?vue&type=template&id=70cab6cc&scoped=true"
import script from "./ProfitAndLossTable.vue?vue&type=script&lang=js"
export * from "./ProfitAndLossTable.vue?vue&type=script&lang=js"

import "./ProfitAndLossTable.vue?vue&type=style&index=0&id=70cab6cc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70cab6cc"]])

export default __exports__
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QMarkupTable});
